import React, { Component } from 'react';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import CustomModal from '.';
import { showNotification } from '@mantine/notifications';
import ColorButton from '../Buttons/ColorButton';
import CopyIcon from '../../../SVGs/copyIcon';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import AiAgentIcon from '../../../../../assets/images/module/general/AiAgentIcon.svg';
import { Checkbox, Group, HoverCard, Modal, Progress, Stack, TextInput } from '@mantine/core';
import EmptyStateContainer from '../EmptyStateContainer/EmptyStateContainer';
import TenantIconBlue from '../../../../../assets/images/module/general/TenantIconBlue.svg';
import { NumericFormat } from 'react-number-format';
import ChatApp from '../../../../../views/pages/Module/OpenApi/ChatApp';
import { connect } from 'react-redux';
import Autoload from '../../../../Autoload';
import RemoveIcon from '@material-ui/icons/Remove';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import CloseIcon from '@material-ui/icons/Close';
import VerticalSplitOutlined from '@material-ui/icons/VerticalSplitOutlined';
import { setAiChatSessionId, setAiChatSessionFolderId } from '../../../../../redux/action/General/generalActions';
import { isAiConsentAccepted } from '../../../../../helpers/aiConsent';
import ChatThreadSidebar, { THREAD_SIDEBAR_WIDTH } from './ChatThreadSidebar';

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;
//'https://dev.hellohousing.de/api/bot-api'
//'http://dev.hellohousing.de:9300'
//'/api/ai-chat-api'
//'https://dev.hellohousing.de/api/bot-api'
const baseUrl = window.location.href.includes('app.')
? 'https://app.hellohousing.de/api/bot-api'
: window.location.href.includes('dev.') ? 'https://dev.hellohousing.de/api/bot-api' : 'http://localhost:3001';

// .ai-chat-dragable-modal (styles.scss) applies padding: 10px on every side — the modal's
// actual content area is this much smaller than the Rnd box's own width/height props, which
// is what this component's `height`/`width` props otherwise report. Left unaccounted for,
// content sized off the raw prop instead of this adjusted value overflows the visible
// rounded/bordered box by exactly this amount.
const MODAL_PADDING = 20;

export class ChatAppModal extends Component {
  state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE,
    // Normally starts minimized and only ever expands via the `false` case in
    // componentDidUpdate below, which fires on a prop *transition*. That never fires when
    // Main.js's minimizeChatAppModal is already `false` on the very first render (e.g.
    // restored from localStorage after a reload) — there's no earlier value to transition
    // from, so this stayed stuck minimized and ChatApp rendered its collapsed view with
    // nothing in it. Reading the prop here instead makes the initial render agree with it.
    minimize: this.props.minimizeChatAppModal !== false,
    messages: [],
    offset: 0,
    getChatLoader: false,
    sessionId: null,
    sessionFolderId: null,
    creditUsage: null,
    threads: [],
    isThreadSidebarExpanded: false,
    isLoadingThreads: false,
    // A prompt handed off from the AI dashboard tile — only ever set once createThread() has
    // actually resolved (see startThreadWithPrompt), so ChatApp never sees it before
    // aiChatSessionId really points at the new thread. Cleared once ChatApp reports it's
    // been sent (onInitialPromptConsumed).
    pendingInitialPrompt: null,
    // Same idea, for the tile's "Datei anhängen" entry — set once the fresh thread is ready,
    // then ChatApp opens its own file picker on it instead of sending anything.
    pendingFileSelectTrigger: null
  };

  // Set while a session is being looked up/created, see initSession.
  sessionInitInFlight = false;
  // The id of the session whose folder is currently being created; redux does
  // not have it yet on a first run.
  pendingSessionId = null;
  // A prompt that arrived (from the dashboard tile) before consent was necessarily in
  // place — an instance field, not state, since it must never reach ChatApp (as
  // pendingInitialPrompt/the initialPrompt prop) until startThreadWithPrompt below has
  // confirmed the new thread actually exists.
  pendingPromptAwaitingThread = null;
  // Guards createThread() from firing more than once for the same pendingPromptAwaitingThread —
  // consent may already be accepted when the prompt arrives (the common case) or still be
  // pending (a brand-new account's first AI touch via the tile), and both paths can run
  // through the same componentDidUpdate check.
  pendingPromptThreadRequested = false;
  // Same idea as pendingPromptAwaitingThread, for the "Datei anhängen" entry.
  pendingFileSelectAwaitingThread = null;
  // Same guard, for pendingFileSelectAwaitingThread.
  pendingFileSelectThreadRequested = false;

  constructor(props) {
    super(props);
  }

  async componentDidMount(){
    document.addEventListener('mousedown', this.handleOutsideClick);
    // Was an unconditional `this.setState({minimize: true})` — harmless redundancy back when
    // the state field itself was always hardcoded to `true`, but now that the field reads
    // `minimizeChatAppModal` off props (see its initializer above) this clobbered that value
    // on every mount, which is exactly why the modal kept reopening minimized after a
    // property-switch reload even though the restored props said otherwise.
    this.setState({minimize: this.props.minimizeChatAppModal !== false});
    await this.initSession();
    // Fetched once up front rather than lazily on first expand: the header icon's hover
    // preview needs the list ready before the user has ever clicked anything.
    this.fetchThreads();
  }

  // The account must accept the AI terms once
  // (account.consents.aiConsentAcceptedOn) before anything AI-related runs.
  hasAiConsent = (props = this.props) => isAiConsentAccepted(props.accountData);

  // Mount path, for an account that already accepted the AI terms: look the
  // session up first and only create one when the lookup comes back empty.
  // The just-accepted case runs initSessionAfterConsent instead.
  initSession = async (accountData = this.props.accountData) => {
    const {setAiChatSessionId, aiChatSessionId, setAiChatSessionFolderId} = this.props;
    if(!this.hasAiConsent({accountData}) || this.sessionInitInFlight){
      return;
    }
    let sessionId = aiChatSessionId;
    if(!sessionId){
      // Both the consent callback and componentDidUpdate's prop diff fire on
      // acceptance; without this the account would get two sessions.
      this.sessionInitInFlight = true;
      try {
        const session = await this.getSessionByUserId();
        console.log('session: ', session);
        if(session?.id){
          sessionId = session.id;
          setAiChatSessionId(sessionId);
          if(session?.folderId){
            setAiChatSessionFolderId(session.folderId);
          }else{
            await this.createSessionFolder(sessionId);
          }
        }else{
          sessionId = await this.createSession();
          setAiChatSessionId(sessionId);
        }
      } finally {
        this.sessionInitInFlight = false;
      }
    }
    // if(!sessionId){
    //   sessionId = await this.createSession();
    //   setAiChatSessionId(sessionId);
    // }    
    console.log('sessionId: ', sessionId);
    this.setState({ sessionId });
  }

  // Consent has just been accepted, so nothing can exist for this account yet:
  // the session is created first and only then read back, which is also what
  // supplies its folderId. The id reaches redux last on purpose — ChatApp
  // watches it and pulls the chat history off it, so the order of calls stays
  // POST /session -> GET /session -> GET /history.
  initSessionAfterConsent = async (accountData = this.props.accountData) => {
    const {setAiChatSessionId, setAiChatSessionFolderId, aiChatSessionId} = this.props;
    if(!this.hasAiConsent({accountData}) || this.sessionInitInFlight || aiChatSessionId){
      return;
    }
    // The consent callback and componentDidUpdate's prop diff both fire on
    // acceptance; without this the account would get two sessions.
    this.sessionInitInFlight = true;
    try {
      const createdSessionId = await this.createSession();
      const session = await this.getSessionByUserId();
      console.log('session: ', session);
      const sessionId = session?.id || createdSessionId || null;
      if(session?.folderId){
        setAiChatSessionFolderId(session.folderId);
      }
      if(sessionId){
        setAiChatSessionId(sessionId);
      }
      this.setState({ sessionId });
    } finally {
      this.sessionInitInFlight = false;
    }
  }

  componentWillUnmount(){
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  componentDidUpdate(prevProps, prevState) {
    if(!this.hasAiConsent(prevProps) && this.hasAiConsent()){
      this.initSessionAfterConsent();
    }

    if(prevState.minimize !== this.state.minimize){
        this.props.setMinimize(this.state.minimize);
    }

    if(prevProps.minimizeChatAppModal === true && this.props.minimizeChatAppModal === false){
        this.setState({minimize: false});
    }

    if(prevProps.open === false && this.props.open === true){
        this.setState({minimize: false});
    }

    if(this.props.initialPrompt?.id && this.props.initialPrompt.id !== prevProps.initialPrompt?.id){
      this.pendingPromptThreadRequested = false;
      this.pendingPromptAwaitingThread = this.props.initialPrompt;
      this.setState({minimize: false});
    }

    // Mirrors initSession's own consent gate — the thread is only created once consent is
    // accepted, whichever of the two lands second. The prompt itself is only handed to
    // ChatApp (via pendingInitialPrompt state, below) once createThread() has actually
    // resolved — ChatApp treats a non-null initialPrompt prop as "the active session is
    // this new thread, safe to send into", and if this component were already open on an
    // existing thread (not a fresh mount), aiChatSessionId would still be that old thread's
    // id for as long as this stays pending. Handing the prompt over early let ChatApp send
    // into whatever thread happened to already be active, and the reset that follows once
    // aiChatSessionId *does* change to the real new thread then wiped the message it had
    // just optimistically added — the fix is to simply not hand it over that early.
    if(this.pendingPromptAwaitingThread && this.hasAiConsent() && !this.pendingPromptThreadRequested){
      this.pendingPromptThreadRequested = true;
      this.startThreadWithPrompt(this.pendingPromptAwaitingThread);
    }

    if(this.props.pendingFileSelect?.id && this.props.pendingFileSelect.id !== prevProps.pendingFileSelect?.id){
      this.pendingFileSelectThreadRequested = false;
      this.pendingFileSelectAwaitingThread = this.props.pendingFileSelect;
      this.setState({minimize: false});
    }

    // Same reasoning as startThreadWithPrompt above.
    if(this.pendingFileSelectAwaitingThread && this.hasAiConsent() && !this.pendingFileSelectThreadRequested){
      this.pendingFileSelectThreadRequested = true;
      this.startThreadWithFileSelect(this.pendingFileSelectAwaitingThread);
    }
  }

  // Clicking anywhere outside the chat panel (including its drag/resize handles)
  // minimizes it instead of leaving it expanded in the background.
  handleOutsideClick = (e) => {
    const { open, fullScreen } = this.props;
    const { minimize } = this.state;
    // The mobile sheet covers the whole screen, so the only things "outside" it are portaled
    // dropdowns (e.g. the credit bar's) — tapping those must not close the chat.
    if(!open || minimize || fullScreen){
      return;
    }
    if(e.target.closest('.ai-chat-dragable-modal') || e.target.closest('[role="dialog"]')){
      return;
    }
    this.setState({minimize: true});
  };

  createSession = async () => {
    try {
      const res = await fetch(`${baseUrl}/session`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', //  this is required
        },
        body: JSON.stringify({
          userId: this.props.profileData?.id,
          encryptedToken: this.props.profileData?.auth?.encryptedToken,
          accountId: this.props.accountData?.accountId
        })
      });
      const { sessionId } = await res.json();
      console.log('sessionId: ', sessionId);
      // POST /session always creates a brand new session document, so it never already has
      // a folder — unlike the old single-session assumption this used to rely on (checking
      // the *previous* active session's aiChatSessionFolderId), which broke the moment a
      // second thread could exist: it would skip creating a folder for thread #2 onward
      // simply because thread #1 already had one.
      await this.createSessionFolder(sessionId);
      return sessionId;
    } catch (e) {
      console.log('error: ', e);
      return null;
    }
  };

  // Lists every thread (session) for this user/account, for the header icon's hover preview
  // and the expanded sidebar panel. Fetched on mount and refetched whenever the list might
  // be stale (expanding the panel, after create/delete, pollForThreadTitle below) rather
  // than cached more cleverly, since a thread's title can change after it's first fetched.
  // `silent` skips the loading flag — used by the background title poll so it doesn't flash
  // a spinner over a list the user might actually be looking at right now.
  fetchThreads = async (silent = false) => {
    if(!silent){
      this.setState({isLoadingThreads: true});
    }
    try {
      const res = await fetch(`${baseUrl}/sessions?userId=${this.props.profileData?.id}&accountId=${this.props.accountData?.accountId}&encryptedToken=${encodeURIComponent(this.props.profileData?.auth?.encryptedToken)}`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      const threads = await res.json();
      this.setState({threads: Array.isArray(threads) ? threads : []});
    } catch (e) {
      console.log('error: ', e);
    } finally {
      if(!silent){
        this.setState({isLoadingThreads: false});
      }
    }
  };

  // The header icon's click handler — opens the persistent inline panel, or closes it back
  // to no reserved width at all if it's already open. Hovering the same icon (see render)
  // shows a lighter floating preview instead, without touching this state.
  toggleThreadSidebar = () => {
    this.setState({isThreadSidebarExpanded: !this.state.isThreadSidebarExpanded});
    this.fetchThreads();
  };

  // sessionTitleService.js (backend) derives a thread's title from its first message
  // fire-and-forget, in parallel with the /ask response itself — nothing about that response
  // guarantees the title has landed by the time it completes. Passed to ChatApp as
  // onMessageSent, called right as a message is sent; polls a few times with a short delay,
  // stopping as soon as the active thread has a title (mirrors ChatApp's own
  // loadHistoryForNewSession retry shape for the same kind of "written slightly later" race).
  // A no-op once the active thread already has one, so this stays cheap on every later
  // message in the same thread.
  pollForThreadTitle = async (attempt = 0) => {
    const MAX_ATTEMPTS = 5;
    const POLL_DELAY_MS = 1800;
    const activeSessionId = this.props.aiChatSessionId;
    const alreadyTitled = this.state.threads.find((t) => t.id === activeSessionId)?.title;
    if(alreadyTitled){
      return;
    }
    await this.fetchThreads(true);
    const nowTitled = this.state.threads.find((t) => t.id === activeSessionId)?.title;
    if(nowTitled || attempt >= MAX_ATTEMPTS){
      return;
    }
    setTimeout(() => this.pollForThreadTitle(attempt + 1), POLL_DELAY_MS);
  };

  createThread = async () => {
    const {setAiChatSessionId} = this.props;
    const sessionId = await this.createSession();
    if(!sessionId){
      return;
    }
    // The new thread's folder is still being created (createSessionFolder, awaited inside
    // createSession, dispatches setAiChatSessionFolderId itself once it lands) — clear the
    // old thread's folder id now rather than leaving it pointed at the wrong thread even
    // briefly.
    setAiChatSessionId(sessionId);
    this.setState({sessionId, sessionFolderId: null}, () => this.fetchThreads());
  };

  // createThread() dispatches setAiChatSessionId synchronously before it resolves, so by the
  // time this `await` resumes, aiChatSessionId is guaranteed to already be the new thread's
  // id — only then is it safe to hand the prompt to ChatApp (see componentDidUpdate).
  startThreadWithPrompt = async (prompt) => {
    await this.createThread();
    this.pendingPromptAwaitingThread = null;
    this.setState({pendingInitialPrompt: prompt});
  };

  // Same reasoning as startThreadWithPrompt.
  startThreadWithFileSelect = async (trigger) => {
    await this.createThread();
    this.pendingFileSelectAwaitingThread = null;
    this.setState({pendingFileSelectTrigger: trigger});
  };

  // Switches the active thread. Also updates aiChatSessionFolderId to the target thread's
  // own folder — ChatApp's file-upload flow reads that from redux, so leaving it pointed at
  // whichever thread was active before would attach new files to the wrong thread's folder.
  switchThread = (sessionId) => {
    const {setAiChatSessionId, setAiChatSessionFolderId} = this.props;
    const thread = this.state.threads.find((t) => t.id === sessionId);
    setAiChatSessionId(sessionId);
    setAiChatSessionFolderId(thread?.folderId || null);
    this.setState({sessionId, sessionFolderId: thread?.folderId || null});
  };

  getSessionByUserId = async () => {
    try {
      const res = await fetch(`${baseUrl}/session?userId=${this.props.profileData?.id}&encryptedToken=${encodeURIComponent(this.props.profileData?.auth?.encryptedToken)}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json', //  this is required
        }
      });
      const response = await res.json();
      console.log('session: ', response);
      return response;
    } catch (e) {
      console.log('error: ', e);
      return null;
    }
  };

  // Deletes any thread, not just the active one, so the sidebar can delete a thread the
  // user isn't currently looking at without switching to it first.
  deleteThread = async (sessionId, sessionFolderId) => {
    const {aiChatSessionId, profileData} = this.props;
    const res = await fetch(`${baseUrl}/session`,
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userId: profileData?.id,
        sessionId,
        sessionFolderId,
        encryptedToken: this.props.profileData?.auth?.encryptedToken, // send as-is (don't URL encode)
      }),
    });
    const { message } = await res.json();
    if(message === 'Success'){
      const remainingThreads = this.state.threads.filter((t) => t.id !== sessionId);
      this.setState({threads: remainingThreads});
      // Only the active thread being deleted needs a replacement — deleting some other
      // thread from the list doesn't touch what's currently open.
      if(sessionId === aiChatSessionId){
        if(remainingThreads.length > 0){
          this.switchThread(remainingThreads[0].id);
        }else{
          // Not initSession(): it reads sessionId off this.props.aiChatSessionId, which
          // (being a redux prop) isn't guaranteed to already reflect the delete by the time
          // this callback runs — it could still see the just-deleted id and wrongly decide a
          // session already exists. createThread() creates unconditionally, no such race.
          this.createThread();
        }
      }
    }
    return true;
  }

  // Renames a thread. Updates the local list in place rather than refetching — same
  // reasoning as deleteThread/pinThread below: the round trip has already told us the new
  // value, no need to re-ask the server for it.
  renameThread = async (sessionId, title) => {
    const {profileData} = this.props;
    try {
      await fetch(`${baseUrl}/session/${sessionId}?userId=${profileData?.id}&encryptedToken=${encodeURIComponent(profileData?.auth?.encryptedToken)}`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ title }),
      });
      this.setState({threads: this.state.threads.map((t) => t.id === sessionId ? {...t, title} : t)});
    } catch (e) {
      console.log('error: ', e);
    }
  };

  // Pins/unpins a thread. Re-sorts the local list the same way getSessionsForUser sorts on
  // the backend (pinned first, otherwise unchanged order) so the row jumps to/from the top
  // immediately instead of waiting on a refetch.
  pinThread = async (sessionId, pinned) => {
    const {profileData} = this.props;
    try {
      await fetch(`${baseUrl}/session/${sessionId}?userId=${profileData?.id}&encryptedToken=${encodeURIComponent(profileData?.auth?.encryptedToken)}`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pinned }),
      });
      const updated = this.state.threads.map((t) => t.id === sessionId ? {...t, pinned} : t);
      updated.sort((a, b) => (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0));
      this.setState({threads: updated});
    } catch (e) {
      console.log('error: ', e);
    }
  };

  createSessionFolder = async (sessionId) => {
      const {propertySelected, accountData} = this.props;
      // handleCreateSessionFolder runs as an HttpRequestAxios callback and
      // cannot read the id from props: on the first run (right after consent)
      // setAiChatSessionId has not been dispatched yet.
      this.pendingSessionId = sessionId;
      const data = new FormData();
      // accountId has to come from accountData, not propertySelected: this folder is
      // account-level (chat isn't scoped to a property) and must be creatable before the
      // account has any property at all, at which point propertySelected is still the
      // reducer's default {} and .accountId would be undefined — sent by FormData as the
      // literal string "undefined" and rejected by the backend.
      data.append('accountId', accountData?.accountId);
      propertySelected?.id && data.append('propertyId', propertySelected.id);
      data.append('name', sessionId);
      data.append('isDirectory', true);
      data.append('isReadOnly', false);
      data.append('isShared', false);
      data.append('fileType', 'ChatBotDocument');
      data.append('referencedObjectId', sessionId);

      Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.document_api_base_url + 'documents',
      'POST',
      data,
      null,
      false,
      true,
      false,
      this,
      'handleCreateSessionFolder',
      null,
      false,
      '',
      {
        //'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
      );
  };

  handleCreateSessionFolder(response){
    const {setAiChatSessionFolderId} = this.props;
    if(response.status && response.statuscode === 200){
      const sessionId = this.pendingSessionId || this.props.aiChatSessionId;
      this.setState({sessionFolderId: response?.result?.id}, async ()=> {
        setAiChatSessionFolderId(response?.result?.id);
        await this.updateSession(response?.result?.id, sessionId);
      });
    }
  }

  updateSession= async (folderId, sessionId = this.props.aiChatSessionId)=>{
    if(!sessionId){
      return;
    }
    const res = await fetch(`${baseUrl}/session/${sessionId}?userId=${this.props.profileData?.id}&encryptedToken=${encodeURIComponent(this.props.profileData?.auth?.encryptedToken)}`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        folderId
      }),
    });
    const { updatedSession } = await res.json();
    console.log('updatedSession: ', updatedSession);
  }
  
  formatCredits = (value) => {
    return Math.round(Math.max(value ?? 0, 0)).toLocaleString('de-DE');
  }

  renderCreditUsageBar = () => {
    const { creditUsage } = this.state;
    if(!creditUsage){
      return null;
    }

    const used = Math.max(creditUsage?.usedCredits ?? 0, 0);
    const includedAvailable = creditUsage?.includedCreditsAvailable === true;
    const included = includedAvailable ? Math.max(creditUsage?.includedCredits ?? 0, 0) : 0;
    const additional = Math.max(creditUsage?.additionallyBookedCredits ?? 0, 0);
    const remaining = Math.max(creditUsage?.remainingCredits ?? 0, 0);
    const creditsFromLastMonth = Math.max(creditUsage?.creditsFromLastMonth ?? 0, 0);
    const total = included + additional + creditsFromLastMonth;
    const percent = total > 0 ? Math.min(100, (used / total) * 100) : (used > 0 ? 100 : 0);
    const overLimit = total > 0 && used > total;
    const addOnCredits = creditUsage?.addOnPricing?.credits ?? 100;
    const addOnEur = creditUsage?.addOnPricing?.eur ?? 2;

    return (
      <HoverCard
      zIndex={9999}
      withinPortal
      openDelay={0}
      closeDelay={100}
      shadow='md'
      position='bottom'
      styles={{dropdown: {maxWidth: '480px', backgroundColor: '#E3E3FC', fontSize: '12px', fontWeight: 400, fontFamily: 'Inter, sans-serif'}}}>
        <HoverCard.Target>
          <Progress
          value={percent}
          size={6}
          radius='xl'
          color={'#5555FF'}
          className='ai-chat-credit-usage-bar'
          style={{width: this.props.fullScreen ? '64px' : '120px'}}/>
        </HoverCard.Target>
        <HoverCard.Dropdown style={{padding: '7px', width: '100%'}}>
          <Stack gap={5} py={2}>
            <span>Sie haben aktuell ein Guthaben von <span style={{fontWeight: 'bold'}}>{this.formatCredits(total)} Einheiten</span>:</span>
            <ul style={{margin: 0, paddingLeft: '20px'}}>
              {includedAvailable &&
              <li>{`Ihr Abonnement beinhaltet monatlich: ${this.formatCredits(included)} Einheiten`}</li>}
              <li>{`Restguthaben aus Vormonat: ${this.formatCredits(creditsFromLastMonth)} Einheiten`}</li>
              <li>{`Zusätzlich gebuchtes KI-Guthaben: ${this.formatCredits(additional)} Einheiten`}</li>
            </ul>
            <span>Sie haben in diesem Abrechnungsmonat <span style={{fontWeight: 'bold'}}>{this.formatCredits(used)} Einheiten</span> KI-Guthaben genutzt.</span>
            <span style={{fontStyle: 'italic'}}>{`Kosten für zusätzliches KI-Guthaben: ${this.formatCredits(addOnEur)} EUR / ${this.formatCredits(addOnCredits)} Einheiten. Zusätzliches KI-Guthaben wird gebucht, wenn das bestehende KI-Guthaben aufgebraucht wurde.`}</span>
          </Stack>
        </HoverCard.Dropdown>
      </HoverCard>
    );
  }

  render() {
    const { minimize, messages, getChatLoader, threads, isThreadSidebarExpanded, isLoadingThreads, pendingInitialPrompt, pendingFileSelectTrigger } = this.state;
    const { open, toggle, className, propertySelected, accountData, profileData, closeChatModal, width, height, fullScreen } = this.props;
    console.log('minimize: ', minimize);
    console.log('messages: ', messages);
    // ChatApp uses its own `width` prop for internal breakpoint/truncation math, not just
    // CSS layout — so the sidebar's current width has to come out of what's passed down, or
    // that math runs against space ChatApp no longer actually has. Collapsed reserves no
    // width at all (the toggle now lives in the header, not a standing strip), so ChatApp
    // gets the full width back exactly as before this feature existed.
    // On the mobile sheet the thread list opens over the chat instead of beside it (see
    // render), so it never takes width away.
    const threadSidebarWidth = isThreadSidebarExpanded && !fullScreen ? THREAD_SIDEBAR_WIDTH : 0;
    const chatAppWidth = minimize ? width : Math.max((parseInt(width) || 0) - threadSidebarWidth, 0);
    // See MODAL_PADDING — the raw `height` prop overstates the modal's actual content area
    // by the Rnd wrapper's own CSS padding. MobileAiChatPanel measures its content box
    // itself, padding already excluded.
    const contentHeight = Math.max((typeof height === 'number' ? height : parseFloat(height) || 0) - (fullScreen ? 0 : MODAL_PADDING), 0);
    return (
        // Deliberately no `overflow: hidden` at this level (or on the Stack/content-row
        // wrappers below) — it clipped more than it was meant to: ChatApp's own "..."
        // attachment/record dropdown (RecordOptions, reactstrap ButtonDropdown) isn't
        // portaled, so it renders inline near the textarea's bottom-right corner, close to
        // this box's edge, and got cut off by the same clip that was added to contain the
        // thread sidebar. The sidebar's own wrapper (further down) keeps its own
        // `overflow: hidden` — narrower in scope, doesn't touch ChatApp's subtree at all —
        // which is enough on its own now that its height is computed correctly (see
        // MODAL_PADDING and align='stretch' below); this outer clip was a redundant extra
        // safety net whose cost turned out to be real.
        <div
        style={{width: '100%', height: contentHeight}}
        onClick={this.handleModelOnClick}>
            <Stack style={{height: '100%'}}>
                <Group justify="space-between" wrap="nowrap" gap={minimize ? 10 : 15} style={{width: '100%', marginTop: minimize === false && '3px', cursor: fullScreen ? 'default' : 'pointer'}} className={fullScreen ? 'ai-chat-mobile-header' : (!minimize && 'ai-chat-modal-drag-handle')}>
                    <Group gap={10} wrap="nowrap">
                        {minimize && <DragIndicatorIcon className={'ai-chat-modal-drag-handle ai-chat-modal-drag-handle-font'}/>}
                        {minimize === false &&
                        // Hover previews the thread list without committing to the expanded
                        // layout; clicking commits to it (toggleThreadSidebar), and clicking
                        // again collapses back to zero reserved width. The preview only makes
                        // sense while collapsed — once expanded, the real panel is right there.
                        <HoverCard
                        zIndex={9999}
                        withinPortal
                        // No hover on touch screens: there a tap opens the list straight away.
                        disabled={isThreadSidebarExpanded || fullScreen}
                        openDelay={200}
                        closeDelay={100}
                        shadow='md'
                        position='bottom-start'>
                          <HoverCard.Target>
                            <VerticalSplitOutlined
                            className={'ai-chat-thread-sidebar-toggle'}
                            style={{fontSize: '16px', cursor: 'pointer', color: '#727293'}}
                            onClick={(e)=> { e.stopPropagation(); this.toggleThreadSidebar(); }}
                            />
                          </HoverCard.Target>
                          {/* onMouseDown stopPropagation: this dropdown renders through a
                              Mantine portal, outside .ai-chat-dragable-modal's DOM subtree —
                              without this, handleOutsideClick's document-level 'mousedown'
                              listener reads any click inside it (a thread row, the "+" button,
                              the row's own context menu) as outside the modal and minimizes it
                              before the click itself ever fires. Same fix as ChatThreadSidebar's
                              own Menu.Dropdown, needed again here since this is a separate
                              portal root. */}
                          <HoverCard.Dropdown onMouseDown={(e)=> e.stopPropagation()} style={{padding: '4px', width: `${THREAD_SIDEBAR_WIDTH}px`, maxHeight: '320px', display: 'flex', flexDirection: 'column', overflow: 'hidden'}}>
                            <ChatThreadSidebar
                            threads={threads}
                            activeSessionId={this.props.aiChatSessionId}
                            isLoading={isLoadingThreads}
                            onCreateThread={()=> this.createThread()}
                            onSelectThread={(id)=> this.switchThread(id)}
                            onDeleteThread={(id, folderId)=> this.deleteThread(id, folderId)}
                            onRenameThread={(id, title)=> this.renameThread(id, title)}
                            onPinThread={(id, pinned)=> this.pinThread(id, pinned)}
                            />
                          </HoverCard.Dropdown>
                        </HoverCard>}
                        <img src={AiAgentIcon} alt='ai-icon' style={{width: '14px'}}/>
                        <span style={{fontSize: '14px', fontWeight: '400', lineHeight: '1.5'}}><strong>hellohousing KI</strong></span>
                    </Group>
                    <Group wrap="nowrap">
                      {minimize === false && this.renderCreditUsageBar()}
                      <Group gap={5} wrap="nowrap">

                        {minimize === false && !fullScreen &&
                        <RemoveIcon
                        className={'ai-chat-modal-minimize'}
                        onClick={()=> this.setState({minimize: !minimize})}
                        />}
                        <CloseIcon
                        className={'ai-chat-modal-close'}
                        onClick={()=> closeChatModal()}
                        />
                    </Group>
                    </Group>
                </Group>
                {open &&
                //minimize === false &&
                // align='stretch': Mantine's Group defaults to align-items: center, not the
                // native flexbox stretch — without this override, the panel and the ChatApp
                // wrapper below would size to their own content instead of filling this row's
                // real height (flex: 1, minHeight: 0 — exactly what's left under the header).
                <Group align='stretch' wrap="nowrap" gap={0} style={{width: '100%', flex: 1, minHeight: 0}}>
                  {/* height is intentionally a few px short of 100% (the stretched default
                      that matches ChatApp's own height exactly) — flush with the modal's
                      bottom edge read as cramped/overflowing-adjacent even though it isn't;
                      this leaves a small visible gap instead. */}
                  {minimize === false && isThreadSidebarExpanded && !fullScreen &&
                  <div style={{width: `${THREAD_SIDEBAR_WIDTH}px`, height: 'calc(100% - 14px)', paddingRight: '10px', display: 'flex', flexDirection: 'column', overflow: 'hidden'}}>
                    <ChatThreadSidebar
                    threads={threads}
                    activeSessionId={this.props.aiChatSessionId}
                    isLoading={isLoadingThreads}
                    onCreateThread={()=> this.createThread()}
                    onSelectThread={(id)=> this.switchThread(id)}
                    onDeleteThread={(id, folderId)=> this.deleteThread(id, folderId)}
                    onRenameThread={(id, title)=> this.renameThread(id, title)}
                    onPinThread={(id, pinned)=> this.pinThread(id, pinned)}
                    />
                  </div>}
                  <div style={{flex: 1, minWidth: 0, height: '100%', position: 'relative'}}>
                    {fullScreen && isThreadSidebarExpanded &&
                    // Full-width overlay on the chat area: beside the chat (the desktop
                    // layout) it would leave a phone's chat about 150px wide. Picking or
                    // starting a thread closes it again, back to the conversation.
                    <div className='ai-chat-mobile-thread-overlay'>
                      <ChatThreadSidebar
                      threads={threads}
                      activeSessionId={this.props.aiChatSessionId}
                      isLoading={isLoadingThreads}
                      onCreateThread={()=> { this.setState({isThreadSidebarExpanded: false}); this.createThread(); }}
                      onSelectThread={(id)=> { this.setState({isThreadSidebarExpanded: false}); this.switchThread(id); }}
                      onDeleteThread={(id, folderId)=> this.deleteThread(id, folderId)}
                      onRenameThread={(id, title)=> this.renameThread(id, title)}
                      onPinThread={(id, pinned)=> this.pinThread(id, pinned)}
                      />
                    </div>}
                    <ChatApp
                    //messages={messages}
                    fullScreen={fullScreen}
                    minimize={minimize}
                    onMinimize={()=> this.setState({minimize: true})}
                    propertyId={propertySelected?.id}
                    token={Autoload.Utils.getAuthToken()}
                    accountId={accountData?.accountId}
                    profileData={profileData}
                    getChatLoader={getChatLoader}
                    width={chatAppWidth}
                    // contentHeight includes the header row above; on the mobile sheet ChatApp
                    // lays itself out with flex, so it just fills what's left under the header.
                    height={fullScreen ? '100%' : contentHeight}
                    history={this.props.history}
                    //getChatHistory={()=> this.getChatHistory()}
                    updateMessages={(messages)=> this.setState({messages})}
                    onCreditUsageChange={(creditUsage)=> this.setState({creditUsage})}
                    // The prop diff in componentDidUpdate covers this too, but the
                    // callback carries the account that was just read back, so the
                    // session is created without waiting for props to settle.
                    onConsentAccepted={(acceptedAccountData)=> this.initSessionAfterConsent(acceptedAccountData)}
                    onMessageSent={()=> this.pollForThreadTitle()}
                    initialPrompt={pendingInitialPrompt}
                    onInitialPromptConsumed={()=> {
                      this.setState({pendingInitialPrompt: null});
                      this.props.onInitialPromptConsumed?.();
                    }}
                    fileSelectTrigger={pendingFileSelectTrigger}
                    onFileSelectTriggerConsumed={()=> {
                      this.setState({pendingFileSelectTrigger: null});
                      this.props.onPendingFileSelectConsumed?.();
                    }}/>
                  </div>
                </Group>}
            </Stack>
            <button id='delete-chat-session-id' style={{display: 'none'}} onClick={()=> this.deleteThread(this.props.aiChatSessionId, this.props.aiChatSessionFolderId)}/>
        </div>
    );
  }
}

const mapStateToProps = (state) => {
    return {
      accountData: state.generalReducer.accountData,
      propertySelected: state.generalReducer.property,
      profileData: state.generalReducer.profile,
      aiChatSessionId: state.generalReducer.aiChatSessionId,
      aiChatSessionFolderId: state.generalReducer.aiChatSessionFolderId
    };
};

const actions = {
  setAiChatSessionId,
  setAiChatSessionFolderId
}

export default connect(mapStateToProps, actions)(ChatAppModal);
